export default class AbstractVertical {

  readonly name: string = 'unknown'
  readonly title: string = 'unknown'
  readonly color: string = '#787878' // https://accessiblepalette.com/?lightness=98.2,93.95,85.1,76.5,67.65,57.8,47.6,40.4,32.4,23.55&fe6f5c=0,0&f8d147=0,-10&56d25b=0,0&0088cb=0,0&387AE6=0,15&66788E=0,0&808080=0,0
  readonly sortWeight: number = 1000

  readonly supportedFeatures: string[] = []

  /**
   * Returns true if this channel supports all of the specified features.
   */
  supports(features: string[]): boolean {
    return features.every((feature) => {
      return this.supportedFeatures.includes(feature)
    })
  }

}
